import type { OrganizationTier } from "../OrgRecord";

/**
 * Query key factory for org queries.
 *
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const orgQueryKeys = {
  all: () => ["orgs"] as const,

  /** Prefix for every paginated org listing. */
  lists: () => [...orgQueryKeys.all(), "list"] as const,
  list: (
    params: { search?: string; tier?: OrganizationTier | "all" },
    pageSize: number,
  ) =>
    [
      ...orgQueryKeys.lists(),
      params.search ?? "",
      params.tier ?? "all",
      pageSize,
    ] as const,

  /** Prefix for every org search. */
  searches: () => [...orgQueryKeys.all(), "search"] as const,
  search: (term: string) => [...orgQueryKeys.searches(), term] as const,

  /** The org record, and the prefix for everything else about that org. */
  org: (orgId: string | undefined) =>
    orgId === undefined
      ? ([...orgQueryKeys.all(), "org"] as const)
      : ([...orgQueryKeys.all(), "org", orgId] as const),

  /** Every member of the org, with their roles. */
  members: (orgId: string | undefined) =>
    [...orgQueryKeys.org(orgId), "members"] as const,
};
